<header class="navbar" [class.navbar--scrolled]="scrolled()">
  <div class="navbar__inner">

    <!-- Logo -->
    <div class="navbar__logo" (click)="scrollTo('hero')" role="button" tabindex="0" aria-label="Ir al inicio">
      <span class="navbar__logo-text">ARUMA TURISMO</span>
    </div>

    <!-- Desktop nav: bordered item row + Contacto button -->
    <nav class="navbar__nav" aria-label="Navegación principal">
      <button class="navbar__item" (click)="scrollTo('talleres')">Talleres</button>
      <button class="navbar__item navbar__item--hug" (click)="scrollTo('colaboraciones')">Eventos privados</button>
      <button class="navbar__item" (click)="scrollTo('about')">Sobre Aruma</button>
      <button class="navbar__item" (click)="scrollTo('faqs')">Dudas</button>
      <div class="navbar__cta-wrap">
        <button class="btn btn-primary navbar__cta" (click)="scrollTo('contacto')">Contacto</button>
      </div>
    </nav>

    <!-- Mobile hamburger -->
    <button
      class="navbar__menu-btn"
      (click)="toggleMenu()"
      aria-label="Abrir menú"
      [attr.aria-expanded]="menuOpen()"
    >
      @if (!menuOpen()) {
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <rect x="3" y="6" width="18" height="1.5" rx="0.75" fill="currentColor"/>
          <rect x="3" y="11.25" width="18" height="1.5" rx="0.75" fill="currentColor"/>
          <rect x="3" y="16.5" width="18" height="1.5" rx="0.75" fill="currentColor"/>
        </svg>
      } @else {
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path d="M6 6L18 18M6 18L18 6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
        </svg>
      }
    </button>
  </div>

  <!-- Mobile overlay menu -->
  @if (menuOpen()) {
    <div class="navbar__mobile-menu" role="dialog" aria-label="Menú de navegación">
      <nav class="navbar__mobile-nav">
        <button class="navbar__mobile-link" (click)="scrollTo('talleres')">Talleres</button>
        <button class="navbar__mobile-link" (click)="scrollTo('colaboraciones')">Eventos privados</button>
        <button class="navbar__mobile-link" (click)="scrollTo('about')">Sobre Aruma</button>
        <button class="navbar__mobile-link" (click)="scrollTo('faqs')">Dudas</button>
        <button class="navbar__mobile-link" (click)="scrollTo('contacto')">Contacto</button>
      </nav>
    </div>
  }
</header>
